"use client"

import type { BlockchainFilter } from "@/app/blockchains/filters/blockchain-filters-scope"
import { ComingSoon } from "@/app/components/coming-soon"
import {
  useLeaderboardActiveLinkChecker,
  useLeaderboardPageHref,
} from "@/app/navigation/leaderboard"
import { LeaderboardPageType } from "@/app/navigation/leaderboard-types"
import { Trans } from "@lingui/react/macro"
import {
  NavigationTabsList,
  NavigationTrigger,
  cn,
} from "@rarible_int/anaconda_ui_components"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { Fragment } from "react"

function extractBlockchainFromPath(pathname: string): BlockchainFilter {
  const paths = pathname.split("/").filter(Boolean)
  return paths[0].toUpperCase() as BlockchainFilter
}

export function CollectionLeaderboardNavigation() {
  const pathname = usePathname()
  const blockchain = extractBlockchainFromPath(pathname)
  const showHolding = blockchain !== "ALL"

  return (
    <NavigationTabsList
      size="lg"
      data-testid="collection-leaderboard-navigation"
    >
      <LeaderboardLink
        pageType={LeaderboardPageType.TRENDING}
        blockchain={blockchain}
      />
      {showHolding && (
        <LeaderboardLink
          pageType={LeaderboardPageType.HOLDING}
          blockchain={blockchain}
        />
      )}
    </NavigationTabsList>
  )
}

const LABEL_BY_PAGE_TYPE: Record<LeaderboardPageType, React.ReactNode> = {
  [LeaderboardPageType.TRENDING]: <Trans>Trending</Trans>,
  [LeaderboardPageType.HOLDING]: <Trans>Holding</Trans>,
  [LeaderboardPageType.WATCHLIST]: <Trans>Watchlist</Trans>,
}

function LeaderboardLink({
  pageType,
  blockchain,
  disabled,
}: {
  pageType: LeaderboardPageType
  blockchain: BlockchainFilter
  disabled?: boolean
}) {
  const Container = disabled ? ComingSoon : Fragment
  const href = useLeaderboardPageHref(pageType, blockchain)
  const active = useLeaderboardActiveLinkChecker(pageType, blockchain)

  return (
    <Container>
      <NavigationTrigger asChild active={active}>
        <Link
          prefetch={false}
          className={cn(disabled && "pointer-events-none")}
          href={href}
        >
          <h4>{LABEL_BY_PAGE_TYPE[pageType]}</h4>
        </Link>
      </NavigationTrigger>
    </Container>
  )
}
